import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axios, ServerError } from 'Lib/axios'

import { useUserStore } from 'Stores/userStoreModuleFed'
import { AccountSettings } from 'Types/AccountSettings'
import { AxiosError } from 'axios'

interface OneParamType {
  [key: string]: string
}

export interface UpdateBillingDetailsApiResponse {
  httpStatusCode: number
  timestamp: string
  result: string
  path: string
  data: AccountSettings
}

const updateData = async (payload: AccountSettings | OneParamType) => {
  const accountId = useUserStore.getState().accountId

  try {
    const response = await axios.put<UpdateBillingDetailsApiResponse>(
      `accounts/${accountId}/setup`,
      payload
    )
    return response.data
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      return error.response.data as ServerError
    }
  }
}

export const useUpdateAccountSettings = () => {
  const queryClient = useQueryClient()
  return useMutation(updateData, {
    onSuccess: () => {
      void queryClient.invalidateQueries(['accountSettings'])
    },
  })
}
